<t-llevo-dialog-header dialogTitle="Detalles del viaje">
  @if (travelStatus()) {
    <edt-tag
      border_radius="8px"
      [color]="travelStatus()! | travelStatusColor"
      class="ms-2 h6 mb-0"
    >
      {{ travelStatus()! | formatTravelStatus }}
    </edt-tag>
  }
</t-llevo-dialog-header>
<mat-dialog-content class="px-0">
  <div
    class="row g-0 h-auto"
    commonui-loader
    [appLoader]="(loaderSrv.loaderState$ | async) ?? false"
    style="min-height: 100% !important"
  >
    <!-- SIDEMENU -->
    <div class="col-3">
      <t-llevo-details-side-menu
        class="sidenav"
        [menu]="sideMenu"
        [activeMenuItem]="activeMenuItem"
        (activeMenuChange)="setActiveMenu($event)"
      ></t-llevo-details-side-menu>
    </div>

    <!-- CONTENT -->
    <div class="row col-9 p-1 main-container mx-0">
      <!-- GENERAL SECTION  -->
      <t-llevo-details-general-section
        class="col-12"
        [hidden]="activeMenuItem !== 'general'"
      >
      </t-llevo-details-general-section>

      <!-- PERSONAL SECTION -->
      <t-llevo-details-personal-section
        class="col-12"
        [hidden]="activeMenuItem !== 'driver-personal'"
      >
      </t-llevo-details-personal-section>

      <!-- LICENSES SECTION  -->
      <t-llevo-details-license-section
        class="col-12"
        [hidden]="activeMenuItem !== 'driver-licenses'"
        [data]="data"
      >
      </t-llevo-details-license-section>

      <!-- VEHICLE SECTION -->
      <t-llevo-details-vehicle-section
        class="col-12"
        [hidden]="activeMenuItem !== 'driver-vehicle'"
      >
      </t-llevo-details-vehicle-section>

      <!-- CLIENT SECTION -->
      <t-llevo-details-client-section
        class="col-12"
        [hidden]="activeMenuItem !== 'client'"
      >
      </t-llevo-details-client-section>
    </div>
  </div>
</mat-dialog-content>
